var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:{ 'kiswe-studio-logo': true, 'kiswe-studio-logo--disabled': !_vm.link },attrs:{"href":_vm.link}},[(_vm.showBrandedLogo)?_c('Media',{attrs:{"src":_vm.branding.logoUrl}}):_c(_vm.loadedComponent,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }